import React from "react";
import IntegrationComponent from "../components/Integrations/IntegrationComponent";

const IntegrationPage = () => {
  return (
<IntegrationComponent/>
  );
};

export default IntegrationPage;
